import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "inlineStyles", "testId", "isRanking", "innerRef", "isSortable"];
import React from 'react';
import { HeadCell } from '../styled/table-head';
var TableHeadCell = function TableHeadCell(_ref) {
  var content = _ref.content,
    inlineStyles = _ref.inlineStyles,
    testId = _ref.testId,
    isRanking = _ref.isRanking,
    innerRef = _ref.innerRef,
    isSortable = _ref.isSortable,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(HeadCell, _extends({
    style: inlineStyles,
    testId: testId && "".concat(testId, "--head--cell"),
    ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest, {
    tabIndex: isSortable ? 0 : undefined,
    isSortable: isSortable
  }), /*#__PURE__*/React.createElement("span", null, content));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default TableHeadCell;